/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-24.
 * Dynamic Table Component
 * Allows to add new records, finally returns an array with all records
 */
import React, { Component } from 'react';
import Add from 'material-ui/svg-icons/content/add';
import { indexOf } from 'lodash';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    IconButton
} from 'material-ui';

class DynamicTable extends Component {

    constructor() {
        super();
        this.state = {
            data: [
                { id: '1', name: 'Name 1', status: 'Status 1' },
                { id: '2', name: 'Name 2', status: 'Status 2' },
                { id: '3', name: 'Name 3', status: 'Status 3' }
            ],
            selected: [1],
            columns: [
                { prop: 'id', title: 'Id', render: (data, row) => `${row.id} | ${data}` },
                { prop: 'name', title: 'Name', render: (data, row) => `${row.id} | ${data}` },
                { prop: 'status', title: 'Status', render: (data, row) => `${row.id} | ${data}` }
            ],
            title: 'Table Title'
        };
    }

    isSelected(index) {
        return this.state.selected.indexOf(index) !== -1;
    }

    render() {
        return (
            <div>
                <Table
                    onRowSelection={(selectedRows) => console.log(selectedRows)}
                    fixedHeader
                    height="300px"
                    showRowHover
                    stripedRows
                    selectable
                    multiSelectable
                >
                    <TableHeader displaySelectAll enableSelectAll>
                        <TableRow>
                            <TableHeaderColumn colSpan="3">
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}
                                >
                                    <h2>{this.state.title}</h2>
                                    <IconButton
                                        tooltip="Agregar Fila"
                                        onTouchTap={() => {
                                            this.setState({ data: [...this.state.data, { id: '1', name: 'Name 1', status: 'Status 1' }] });
                                        }}
                                    >
                                        <Add />
                                    </IconButton>
                                </div>
                            </TableHeaderColumn>
                        </TableRow>
                        <TableRow>
                            {
                                this.state.columns.map(({ title }, index) =>
                                    <TableHeaderColumn key={index}>{title}</TableHeaderColumn>
                                )
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {
                            this.state.data.map((row, index) => {
                                return (
                                    <TableRow key={index}>
                                        {
                                            this.state.columns.map((column, ind) => {
                                                return (
                                                    <TableRowColumn key={ind}>
                                                        {column.render(row[column.prop], row)}
                                                    </TableRowColumn>
                                                );
                                            })
                                        }
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default DynamicTable;



// WEBPACK FOOTER //
// ./components/data-containers/dynamicTable.js